import {
  CreateVoucherActive,
  GetListResponse,
  VoucherActive,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _VoucherActiveService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<VoucherActive>>(
      "/admin/api/v2/voucher-active",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public create(voucherActive: CreateVoucherActive) {
    return HttpService.post("/admin/api/v2/voucher-active", {
      body: { ...voucherActive },
    });
  }

  public update(voucherActiveId: number, voucherActive: CreateVoucherActive) {
    return HttpService.patch(
      `/admin/api/v2/voucher-active/${voucherActiveId}`,
      {
        body: { ...voucherActive },
      }
    );
  }
}

const VoucherActiveService = new _VoucherActiveService();

export default VoucherActiveService;
